module.exports = __webpack_public_path__ + "static/media/KUZMA XL AIR TURNTABLE.046f5100.png";